@import 'src/global/variables';

:host {
    color: $color-grey-500;
}

.infobox-content {
    &-open {
        position: absolute;
        // overflow: auto;
        padding: 1rem;
        z-index: 10;
        cursor: default;
        background-color: $color-text-900;
        color: $color-white;
        font-size: initial;
        margin-top: 10px;

        &:after {
            content: "";
            display: block;
            width: 0;
            height: 0;
            position: absolute;
            top: 0;
            right: 0;
            border-style: solid;
            border-width: 0 9px 10px 9px;
            border-color: transparent transparent $color-text-900 transparent;
            transform: translate(-25%, -100%);
        }

        @media #{$screen-max-sm} {
            left: 1em !important;
            right: 1em !important;
            // transform: translateY(-100%);
        }

        @media #{$screen-min-sm} {
            transform: translateX(-100%);
            max-width: 455px;
        }
    }

    &-hidden {
        display: none;
    }

    &__title {
        font-size: 1rem;
        margin-block: 0 1rem;
    }
}
